// ----------------------------------------------------------------------
export const Autocomplete = ({ theme }) => {
    return {
        MuiAutocomplete: {
            styleOverrides: {
                paper: { boxShadow: theme.shadows[25].z20 }
            }
        }
    };
};
//# sourceMappingURL=Autocomplete.js.map